import {GALinkStatus} from '../../util/uiconstants';
const checkDisabled = (linkStatusId) => {
	return (
		linkStatusId === GALinkStatus.Accepted ||
		linkStatusId === GALinkStatus.ComponentNotUsingCanvas ||
		linkStatusId === GALinkStatus.Pending ||
		linkStatusId === GALinkStatus.ComponentReferenceOnly ||
		linkStatusId === GALinkStatus.InvalidPointOfContact ||
		linkStatusId === GALinkStatus.Unlinked ||
		linkStatusId === GALinkStatus.NoPointOfContact
	);
};

export default (scopes) => {
	return scopes
		.map(({gaScopeId: id, gaScopeName: label,  gaScopeTypeId: type, isSubScope, teamList}) => ({
			id,
			type,
			label,
			isSubScope,
			selected: false,
			disabled: false,
			teamList: teamList.map(
				({
					concurrencyToken,
					gaComponentId: teamId,
					teamName,
					pocgui,
					pocText,
					linkSentDate,
					gaLinkStatusId: linkStatusId,
					gaInstructionStatusId: instructionStatusId
				}) => ({
					concurrencyToken,
					teamId,
					teamName,
					pocgui,
					pocText,
					linkSentDate,
					linkStatusId,
					instructionStatusId,
					selected: !checkDisabled(linkStatusId),
					disabled: checkDisabled(linkStatusId)
				})
			)
		}))
		.sort((a, b) => {
			if (a.type === b.type && a.isSubScope && b.isSubScope) {
				return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
			}
			return a.type - b.type;
		});
};
